// Chakra imports
import { 
    Flex, 
    FormLabel, 
    Select, 
    Text, 
    useColorModeValue,
    Box 
  } from '@chakra-ui/react';
  
  interface PickListOption {
    value: string;
    label: string;
  }
  
  export default function Picklist(props: {
    id?: string;
    label?: string;
    extra?: JSX.Element;
    placeholder?: string;
    options?: PickListOption[] | string[];
    required?: boolean;
    isInvalid?: boolean;
    [x: string]: any;
  }) {
    const { 
      id, 
      label, 
      extra, 
      placeholder, 
      options, 
      mb, 
      required, 
      isInvalid,
      ...rest 
    } = props;
    
    // 🎨 Chakra Color Mode
    const textColorPrimary = useColorModeValue('gray.800', 'whiteAlpha.900');
    const textColorSecondary = useColorModeValue('gray.500', 'gray.400');
    const bgPrimary = useColorModeValue('white', 'gray.800');
    const borderColor = useColorModeValue('gray.200', 'gray.600');
    const focusBorderColor = useColorModeValue('blue.400', 'blue.300');
    const hoverBorderColor = useColorModeValue('gray.300', 'gray.500');
    const invalidBorderColor = useColorModeValue('red.400', 'red.300');
  
    return (
      <Flex direction="column" mb={mb ?? '24px'} width="100%">
        {label && (
          <FormLabel
            display="flex"
            htmlFor={id}
            fontSize="sm"
            color={textColorPrimary}
            fontWeight="semibold"
            mb="6px"
          >
            {label}
            {required && <Text as="span" color="red.400" ml="1">*</Text>}
            {extra && (
              <Text fontSize="xs" ml="2" color={textColorSecondary} fontWeight="normal">
                {extra}
              </Text>
            )}
          </FormLabel>
        )}
        
        <Box position="relative">
        <Select
  {...rest}
  id={id}
  variant="outline"
  placeholder={placeholder}
  fontSize="sm"
  fontWeight="medium"
  borderRadius="10px"
  borderWidth="1px"
  borderColor={isInvalid ? invalidBorderColor : borderColor}
  color={textColorPrimary}
  bg={useColorModeValue('gray.50', 'gray.700')}  // 🌟 más claro en light, más suave en dark
  transition="all 0.2s ease"
  _placeholder={{ 
    color: textColorSecondary, 
    fontWeight: 'normal',
  }}
  _hover={{
    borderColor: isInvalid ? invalidBorderColor : hoverBorderColor,
    bg: useColorModeValue('white', 'gray.600'),  // en hover se ilumina
    boxShadow: 'sm',
  }}
  _focus={{
    borderColor: isInvalid ? invalidBorderColor : focusBorderColor,
    bg: useColorModeValue('white', 'gray.600'),  // en focus aún más claro
    boxShadow: `0 0 0 2px ${isInvalid ? invalidBorderColor : focusBorderColor}`,
  }}
  _disabled={{
    opacity: 0.6,
    cursor: "not-allowed",
  }}
>
  {options?.map((option) =>
    typeof option === 'string' ? (
      <option key={option} value={option}>
        {option}
      </option>
    ) : (
      <option key={option.value} value={option.value}>
        {option.label}
      </option>
    )
  )}
</Select>

        </Box>
      </Flex>
    );
  }
  